/* eslint-disable sonarjs/no-duplicate-string */
import { CONTACTS } from 'constants/contactInfo';
import { URL_BASE } from 'constants/routes';

import { Locale } from '@skippay/core/@types/country';
import { formatPhoneNumber } from '@skippay/core/utils/apiUtils';

const CUSTOMER_SERVICE = `customer service`;

const getContactInfo = (locale: Locale = 'cs') => {
	const contacts = CONTACTS(locale);
	const contactPhone = contacts.phone ? formatPhoneNumber(contacts.phone) : undefined;

	return { contactPhone, url: contacts.url };
};

export const corporateContact = (locale: Locale = 'cs') => {
	const { contactPhone, url } = getContactInfo(locale);

	if (!contactPhone) {
		return {
			'@context': 'https://schema.org',
			'@type': 'Organization',
			url,
		};
	}

	return {
		'@context': 'https://schema.org',
		'@type': 'Organization',
		url,
		contactPoint: [
			{
				'@type': 'ContactPoint',
				telephone: contactPhone,
				contactType: CUSTOMER_SERVICE,
				contactOption: 'TollFree',
				areaServed: locale === 'cs' ? 'CZ' : 'SK',
			},
			{
				'@type': 'ContactPoint',
				telephone: contactPhone,
				contactType: CUSTOMER_SERVICE,
			},
			{
				'@type': 'ContactPoint',
				telephone: contactPhone,
				contactType: CUSTOMER_SERVICE,
				contactOption: ['HearingImpairedSupported', 'TollFree'],
				areaServed: locale === 'cs' ? 'CZ' : 'SK',
			},
			{
				'@type': 'ContactPoint',
				telephone: contactPhone,
				contactType: 'technical support',
				contactOption: 'TollFree',
				areaServed: locale === 'cs' ? ['CZ', 'EN'] : ['SK', 'EN'],
				availableLanguage: locale === 'cs' ? ['Czech', 'English'] : ['Slovak', 'English'],
			},
			{
				'@type': 'ContactPoint',
				telephone: contactPhone,
				contactType: 'bill payment',
				contactOption: 'TollFree',
				areaServed: locale === 'cs' ? ['CZ'] : ['SK'],
			},
		],
	};
};

export const socialProfile = (locale: Locale = 'cs') => {
	const { url } = getContactInfo(locale);

	return {
		'@context': 'https://schema.org',
		'@type': 'Person',
		name: 'Skip Pay',
		url,
		sameAs: [
			'http://www.facebook.com/skippay.cz/',
			'https://cz.linkedin.com/company/skip-pay',
			'https://www.youtube.com/channel/UC56ivZwb5fjA7ClI49aMyIg',
		],
	};
};

export const speakable = (locale: Locale = 'cs') => {
	const { url } = getContactInfo(locale);

	return {
		'@context': 'http://schema.org/',
		'@type': 'WebPage',
		name: 'Skip Pay web',
		speakable: ['#myhead1', '#thesummary'],
		url,
	};
};

const getUrlBaseByLocale = (locale: Locale = 'cs') => {
	const key = locale.toUpperCase() as keyof typeof URL_BASE;
	return URL_BASE[key]?.url || URL_BASE.CZ.url;
};

export const webpage = (locale: Locale = 'cs') => {
	const { url } = getContactInfo(locale);

	return {
		'@context': 'http://schema.org',
		'@id': url,
		'@type': 'WebPage',
		url,
		name: getUrlBaseByLocale(locale),
	};
};
